import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "flex items-center justify-end mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "px-6 py-4 border bg-white",
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_input, {
        placeholder: "ID",
        disabled: _ctx.loading,
        value: _ctx.state.id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.id) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Поставщик",
        disabled: _ctx.loading,
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.companyId) = $event)),
        "search-without-refresh": "",
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        class: "mt-2"
      }, null, 8, ["disabled", "loading", "failed", "options", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Код 1С",
        disabled: _ctx.loading,
        value: _ctx.state.code1C,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.code1C) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата создания с",
        disabled: _ctx.loading,
        value: _ctx.state.createdAtFrom,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.createdAtFrom) = $event)),
        type: "date"
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата создания по",
        disabled: _ctx.loading,
        value: _ctx.state.createdAtTo,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.createdAtTo) = $event)),
        type: "date"
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "ТМЦ",
        disabled: _ctx.loading,
        loading: _ctx.data_state.tmc.is_loading,
        failed: _ctx.data_state.tmc.is_failed,
        "error-text": "При получении списка ТМЦ произошла ошибка",
        options: _ctx.data_state.tmc.list,
        value: _ctx.state.inventoryItemId,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.inventoryItemId) = $event)),
        "infinite-scroll": "",
        "search-by": "name",
        onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
        onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
        onSearch: _ctx.searchTMC,
        onOptionBySearch: _ctx.unshiftFindedTMC
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_input, {
        placeholder: "№ Заявки Jira",
        disabled: _ctx.loading,
        value: _ctx.state.jiraNumber,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.jiraNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_input, {
        disabled: _ctx.loading,
        placeholder: "Доверенность",
        value: _ctx.state.warrantNumber,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.warrantNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "Статус",
        disabled: _ctx.loading,
        loading: false,
        failed: false,
        "error-text": "При получении списка статусов произошла ошибка",
        options: _ctx.STATUSES,
        searchable: false,
        value: _ctx.state.statusId,
        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.statusId) = $event))
      }, null, 8, ["disabled", "options", "value"]),
      _createVNode(_component_checkbox, {
        label: "Вторичные материалы",
        class: "mt-2",
        value: _ctx.state.isSecondMaterial,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.isSecondMaterial) = $event)),
        "return-integer": ""
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        class: "small second text mr-3",
        type: "button",
        loading: _ctx.loading,
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "small primary text",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}